import React from "react";
import { EncargoViewType, TaxHistoryData } from "./EncargosAccordion";

export function TableEncargos({
  data,
  type,
}: {
  data: TaxHistoryData[];
  type: EncargoViewType;
}) {
  const fmtBRL = (v: number) =>
    v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const getMonthName = (month: number, year: number) => {
    const names = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    return month >= 1 && month <= 12
      ? `${names[month - 1]} de ${year}`
      : "Mês inválido";
  };

  return (
    <>
      <div className="d-md-none" style={{ maxHeight: 320, overflowY: "auto" }}>
        {Array.isArray(data)
          ? data.map((item, idx) => (
              <div className="card mb-2" key={idx}>
                <div className="card-body">
                  <div className="d-flex justify-content-between text-center">
                    <strong>{type === "agent" ? "Agente" : "Unidade"}</strong>
                    <span>
                      {type === "agent"
                        ? item.agentName
                        : item.name.split(" - ").slice(1).join(" - ")}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <strong>Mês/Ano</strong>
                    <span>{getMonthName(item.month, item.year)}</span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Energia de reserva</strong>
                    <span>{fmtBRL(item.energyReserveTax)}</span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Garantia financeira</strong>
                    <span className="text-truncate">
                      {fmtBRL(item.financialGuaranteeTax)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Reserva de capacidade</strong>
                    <span>{fmtBRL(item.capacityReserveTax)}</span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Reserva de capacidade</strong>
                    <span>{fmtBRL(item.quotaNuclearTax)}</span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Crédito MCP</strong>
                    <span>{fmtBRL(item.mcpCreditTax)}</span>
                  </div>

                  <hr className="my-2" />

                  <div className="d-flex justify-content-between text-center">
                    <span>Total de encargos</span>
                    <strong>{fmtBRL(item.totalWithoutAssociative)}</strong>
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>

      <div className="d-none d-md-block" style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "16px",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f5f5f5",
                borderBottom: "2px solid #0072ce",
              }}
            >
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                {type === "agent" ? "Agente" : "Unidade"}
              </th>

              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Mês/Ano
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Energia de reserva
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Garantia financeira
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Reserva de capacidade
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Cota nuclear
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Crédito MCP
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Total de encargos
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data)
              ? data.map((item, idx) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: "1px solid #e0e0e0",
                      backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    }}
                  >
                    <td
                      style={{
                        padding: "12px",
                        fontSize: "13px",
                      }}
                    >
                      {type === "agent"
                        ? item.agentName
                        : item.name.split(" - ").slice(1).join(" - ")}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        fontSize: "13px",
                      }}
                    >
                      {getMonthName(item.month, item.year)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.energyReserveTax)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.financialGuaranteeTax)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.capacityReserveTax)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.quotaNuclearTax)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.mcpCreditTax)}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtBRL(item.totalWithoutAssociative)}
                    </td>
                  </tr>
                ))
              : null}
            {Array.isArray(data) && data.length > 0 && (
              <tr
                style={{
                  borderTop: "2px solid #0072ce",
                  backgroundColor: "#e8f4fd",
                }}
              >
                <td
                  colSpan={6}
                  style={{
                    fontSize: "14px",
                  }}
                ></td>
                <td
                  style={{
                    padding: "12px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  Total de encargos:
                </td>
                <td
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#28a745",
                  }}
                >
                  {fmtBRL(
                    data.reduce(
                      (acc, item) => acc + (item.totalWithoutAssociative || 0),
                      0
                    )
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
